<div class="padding flex column start">
	<h4 class="margin-bottom-small">Create new order</h4>

	<div class="flex center full-width between">
		<b>Products</b>
		<span class="grey">{{ data.warehouse?.description }}</span>
	</div>

	<div class="full-width fix-height scrollable flex column bg-light-grey padding-small margin-top-smallest">
		@for (item of data.styles; track item) {
			<div class="flex column">
				<div class="flex center between">{{ item.brand.name }} - {{ item.code }} - {{ item.name }}</div>
				<div class="grey">
					@for (color of item.colors; track color; let last = $last) {
						<div class="flex center">{{ color.name }} {{ color.size?.name }}</div>
					}
				</div>
			</div>
		}
	</div>

	<div class="fix-width flex column margin-top">
		<div class="flex center between">
			<b>
				Photographer
				@if (!orderValidation.photographer) {
					<span class="red margin-left">Required field</span>
				}
			</b>
			<button type="button" class="radius-bottom-none" (click)="openEditPhotographerModal(); orderValidation.photographer = true">
				<i class="fa-solid fa-edit"></i>
				Edit
			</button>
		</div>
		<div class="border blue padding flex center">
			@if (order?.photographer) {
				<div class="placeholder bg-primary white">
					<i class="fa fa-user"></i>
				</div>
				<div class="flex column margin-left-small">
					{{ order?.photographer?.fullName }}
					<div class="flex center primary hover margin-top-smallest disabled">
						View Details
						<i class="fa-solid fa-arrow-up-right-from-square margin-left-smallest"></i>
					</div>
				</div>
			} @else {
				Select a photographer
			}
		</div>

		<div class="flex column margin-top">
			<b>Order type</b>
			<div class="flex center margin-top-smallest ">
				<div class="flex gap center">
					@for (type of orderTypes; track type) {
						<div class="flex center column {{ type.selected ? 'border bg-lightest-blue' : '' }} padding-small hover " (click)="selectOrderType(type)">
							<div class="flex-1">
								<div class="placeholder {{ type.name }}"></div>
							</div>

							<div class="flex-0 flex column margin-top-smallest">
								<b>{{ type.name }}</b>
							</div>
						</div>
					}
				</div>
			</div>
		</div>

		<div class="flex column margin-top">
			<b>
				Creation date
				<i class="margin-left-smallest fa fa-lock grey"></i>
			</b>
			<div class="flex margin-top-smallest disabled">
				<input type="text" class="flex-1" [matDatepicker]="creationDatePicker" matInput [(ngModel)]="order.creationDate" />
				<mat-datepicker #creationDatePicker></mat-datepicker>
				<button class="radius-left-none" (click)="creationDatePicker.open()">
					<mat-icon class="small margin-right-smallest">calendar_month</mat-icon>
					Edit
				</button>
			</div>
		</div>

		<div class="flex column margin-top">
			<b>
				Due date
				@if (!orderValidation.dueDate) {
					<span class="red margin-left">Required field</span>
				}
			</b>
			<div class="flex margin-top-smallest">
				<input type="text" class="flex-1" [matDatepicker]="dueDatePicker" matInput [min]="todayDate" [(ngModel)]="order.dueDate" />
				<mat-datepicker #dueDatePicker></mat-datepicker>
				<button class="radius-left-none" (click)="dueDatePicker.open(); orderValidation.dueDate = true">
					<mat-icon class="small margin-right-smallest">calendar_month</mat-icon>
					Edit
				</button>
			</div>
		</div>

		<div class="flex column margin-top">
			<b>Notes</b>
			<textarea class="notes full-width margin-top-smallest" matInput [(ngModel)]="order.notes" style="resize: none; overflow: auto"></textarea>
		</div>

		<div class="flex column end margin-top">
			<div class="flex center">
				<button class="stroked margin-right-smallest" (click)="close()">
					<i class="fa-solid fa-undo"></i>
					Close
				</button>
				<button (click)="saveChanges()">
					<i class="fa fa-check"></i>
					Create order
				</button>
			</div>
		</div>
	</div>
</div>

@if (loading) {
	<bt-loader></bt-loader>
}
